<template>
  <div>
    <!-- @submit.prevent="submit" -->
    <b-form method="POST" id="form-contact" class="form-contacto" enctype="multipart/form-data">
      <b-form-group id="input-group-1" class="form-groups" label-for="input-1">
        <b-form-input
          id="input-1"
          size="sm"
          class="input-personalizado shadow-sm"
          type="text"
          name="name"
          v-model="nombre"
          placeholder="Nombre"
          required
        ></b-form-input>
      </b-form-group>
      <b-form-group id="input-group-2" class="form-groups" label-for="input-2">
        <b-form-input
          id="input-2"
          size="sm"
          class="input-personalizado shadow-sm"
          type="text"
          name="name"
          v-model="asunto"
          placeholder="Asunto"
          required
        ></b-form-input>
      </b-form-group>
      <b-form-group id="input-group-3" class="form-groups" label-for="input-3">
        <b-form-textarea
          id="input-3"
          size="sm"
          class="input-personalizado shadow-sm"
          name="message"
          v-model="mensaje"
          required
          rows="5"
          placeholder="Mensaje"
        ></b-form-textarea>
      </b-form-group>
      <div>
        <b-alert
          :show="dismissCountDown"
          dismissible
          variant="success"
          @dismissed="dismissCountDown=0"
          @dismiss-count-down="countDownChanged"
          class="alerta mx-auto"
        >{{alerta}}</b-alert>
        <a
          type="submit"
          class="btn-enviar mt-2 text-white shadow-sm"
          @click="submit"
          :href="'mailto:' + email + '?&subject=' + asunto + '&body=De%20' + nombre + '%0D%0A' + mensaje"
        >Enviar un correo</a>
      </div>
    </b-form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dismissSecs: 10,
      dismissCountDown: 0,
      email: "rick181221@gmail.com",
      nombre: "",
      mensaje: "",
      asunto: "",
      alerta: ""
    };
  },
  methods: {
    submit() {
      this.dismissCountDown = this.dismissSecs;
      this.alerta =
        "Recuerde revisar nuestros horarios, gracias por contactarnos!!";
      /* this.nombre = "";
      this.mensaje = "";
      this.asunto = ""; */
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    }
  }
};
</script>
<style scoped>
.form-contacto input,
textarea {
  font-size: 1rem;
}

.input-personalizado {
  border: 1px solid rgba(0, 0, 0, 0.06);
  height: 105%;
  padding: 20px 15px;
  line-height: 1;
  padding: 12px 20px;
}
.form-groups textarea {
  height: 100px;
}
.form-groups {
  border-radius: 3px;
  margin: 15px auto;
  width: 80%;
  text-align: left;
}
@media screen and (max-width: 768px) {
  .form-groups,
  .btn-enviar {
    width: 100% !important;
  }
}
.alerta,
.btn-enviar {
  width: 80%;
}

a {
  font-weight: 500;
  font-size: 1.1em;
}
.btn-enviar {
  border-radius: 3px;
  background: #009cff;
  border: none;
  padding: 8px 20px;
}
</style>